/* eslint-disable react/prop-types */
import React from 'react'
import Image from 'components/image'
import classNames from 'classnames'
import { InfoButton } from 'components/buttons'
import { numberToCurrency } from 'lib/money'
import { track, useTracking } from 'lib/analytics'

export const Offer = ({ offer, openRedirectModal, registry, regItem }) => {
  const { price, storeDisplayName, storeIconName, url } = offer
  const tracker = useTracking()
  const handleOfferClick = () => {
    openRedirectModal({
      url,
      storeDisplayName,
      regItem,
      isShopRegistryView: false,
      onRedirectSuccess: () => {},
    })
    tracker.trackEvent({
      event: track.registryProductOfferClicked,
      minEstimate: regItem.deliveryEstimate?.min,
      maxEstimate: regItem.deliveryEstimate?.max,
      offerIds: regItem.offers.map(({ id }) => id),
      regItemId: regItem.id,
      showerDate: registry.showerInfo?.showers[0]?.date,
      willArriveBeforeShower: regItem.deliveryEstimate?.arrivesBeforeShower,
      store: storeDisplayName,
    })
  }
  return (
    <div
      className="flex ptm align-center small"
      role="button"
      style={{ cursor: 'pointer' }}
      tabIndex={0}
      onClick={handleOfferClick}
      onKeyPress={handleOfferClick}
    >
      <span
        className={classNames(
          'icon-offer',
          `icon-offer-${storeIconName}`,
          'mrs'
        )}
      />
      <span className="flex-grow text-overflow-ellipsis prs">
        {storeDisplayName}
      </span>
      {price ? <span className="small">{numberToCurrency(price)}</span> : null}
      <div className="plm">
        <InfoButton empty pill className="phl" size="small">
          Buy{' '}
          <Image
            alt="Open New Tab Icon"
            lazyLoad={false}
            src="https://images.babylist.com/image/upload/v1631884523/redirect_arrow_quj8qr.svg"
          />
        </InfoButton>
      </div>
    </div>
  )
}
